import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  private _title = new BehaviorSubject<string>('');

  get title(): Observable<string> {
    return this._title;
  }

  /**
   * @deprecated - Not is necessary call this more, the system do this automatic
   * @todo - remove this implementation from your class
   * @param title
   */
  setTitle(title: string) {
    return;
    // this._title.next(title);
  }

  set title(title: string) {
    this._title.next(title);
  }
}
